/*jshint esversion: 6 */
import store from '@/store/index';

function Template(payload) {
  let route = {
    path: ':milestone_id',
    name: 'TrainMilestonesDetails',
    component: () => import(
       
       '@/views/Project/Milestones/TrainMilestonesDetails.view.vue'),
    props: (route) => {
      return {
        project_id: parseInt(route.params.project_id),
        milestone_id: parseInt(route.params.milestone_id),
      };
    },
    beforeEnter: (to, from, next) => {
      if (store.getters['Project/isEditMode']) {
        next({
          name: 'TrainMilestonesEdit',
          params: {milestone_id: to.params.milestone_id},
        });
      } else {
        next();
      }
    },
    meta: {
      requiresAuth: true
    },
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
